import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { RfqLotService } from '@app/core/rfq-lots/services/rfq-lots.service';
import { EFeatureFlag } from '@app/feature-toggle-list';

@Component({
  selector: 'cnc-rfq-lot-form',
  templateUrl: './rfq-lot-form.component.html',
  styleUrls: ['./rfq-lot-form.component.scss'],
})
export class RfqLotFormComponent implements OnInit {
  @Output()
  newLot = new EventEmitter<any>();

  @Input()
  rfqId :number = 0;

  @Input()
  quantityOriginal :number = 0;

  @Input()
  purchaseOrderId :number = 0;

  @Input()
  rfqIds :number[] = [];

  @Input()
  bulkUpdate :boolean = false;

  loading :boolean = false;
  pageTitle :string = 'Create a new Lot';
  lotDetails :any = {};

  featureFlag = EFeatureFlag;

  private onDestroy$ = new Subject();

  constructor(
    public activeModal :NgbActiveModal,
    public rfqLotSvc :RfqLotService,
    private toastr :ToastrService,
  ) {}

  ngOnInit() {
    if (this.bulkUpdate) {
      this.lotDetails.rfqIds = [...new Set(this.rfqIds)];
    } else {
      this.lotDetails.rfqId = this.rfqId;
    }

    this.lotDetails.quantityOriginal = this.quantityOriginal;
    this.lotDetails.purchaseOrderId = this.purchaseOrderId;
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onSubmit() :void {
    this.loading = true;

    if (!this.lotDetails.productionDate) {
      Swal.fire({
        title: 'Form Error!',
        text: 'Please set a production date',
        type: 'error',
        confirmButtonText: 'Back to Form',
      });

      return;
    }
    if (!this.lotDetails.expiryDate) {
      Swal.fire({
        title: 'Form Error!',
        text: 'Please set an expiry date',
        type: 'error',
        confirmButtonText: 'Back to Form',
      });

      return;
    }

    if (this.bulkUpdate) {
      this.bulkCreateLot();
    } else {
      this.createLot();
    }
  }

  createLot() :void {
    this.rfqLotSvc
      .create(this.lotDetails)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (resp) => {
          this.toastr.success('New rfq lot created');
          this.loading = false;
          this.activeModal.close(resp);
        },
        (error) => {
          this.loading = false;
          this.toastr.error(
            error.error ??
              'Error creating rfq lot. Please try again later or contact support.',
          );
        },
      );
  }

  bulkCreateLot() :void {
    this.rfqLotSvc
      .bulkCreate(this.lotDetails)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (resp) => {
          this.toastr.success('Rfq Lot created successfully.');
          this.loading = false;
          this.activeModal.close(resp);
        },
        (error) => {
          this.loading = false;
          this.toastr.error(
            error.error ??
              'Error creating rfq lot. Please try again later or contact support.',
          );
        },
      );
  }
}
